
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void; // Add onClick prop
}

export const NavLink = ({ to, children, className, onClick }: NavLinkProps) => {
  const location = useLocation();
  const isActive = location.pathname === to || location.pathname.startsWith(`${to}/`);
  
  return (
    <Link 
      to={to} 
      className={cn(
        "relative px-3 py-2 text-gray-600 font-medium transition-colors",
        "hover:text-primary hover:bg-primary/5 rounded-md",
        isActive && "text-primary font-semibold after:absolute after:bottom-0 after:left-3 after:right-3 after:h-0.5 after:bg-primary", 
        className
      )}
      onClick={onClick} // Pass onClick prop to Link
    >
      {children}
    </Link>
  );
};
